import { Either } from 'src/utils/either';
import { endpoints } from 'src/utils/axios';

import { httpResponseHandler } from 'src/http/http-response-handler';

import {
  HttpTypes,
  BadRequestError,
  ConnectionError,
  UnexpectedError,
  AccessDeniedError,
  InternalServerError,
  TooManyRequestsError,
} from '../../http';

export class MyLevelRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async getMyLevelInfo(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.myLevel.myLevelInfo,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getNextLevelBenefits(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.myLevel.nextLevelBenefits,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
